import React, { FC, useEffect } from 'react';
import BreadcrumbComponent from '@views/components/breadcrumb/Breadcrumb';
import Placeholder from './placeholder';
import _convertUrl from '@helpers/convert-to-url';
import { INTERNAL_URI, categoryHref } from '@helpers/route';
import _get from 'lodash/get';
import _orderBy from 'lodash/orderBy';
import { useCategoryTreeLazyQuery } from 'src/generated/graphql';

const getCategoryBreadcrumb = (categories: any) => {
  return _orderBy(categories, ['path', 'asc'])
    .filter((item) => item.isActive && item.id > 1)
    .map((item) => ({
      active: false,
      href: INTERNAL_URI.CATEGORY,
      as: categoryHref(_get(item, 'id'), _get(item, 'urlKey')),
      name: _get(item, 'name'),
    }));
};

export const Breadcrumb: FC<any> = ({ id, data, loading, error }) => {
  const parentId = data.get('parentId');

  const [
    getCategoryTree,
    { data: tree, loading: treeLoading, error: treeError },
  ] = useCategoryTreeLazyQuery();
  const categoriesBreadcrumb = getCategoryBreadcrumb(_get(tree, 'data'));

  useEffect(() => {
    if (parentId && parentId != 1) {
      getCategoryTree({ variables: { id: parseInt(parentId) } });
    }
  }, [parentId]);

  if (loading || error || treeLoading) {
    return <Placeholder />;
  }

  return (
    <BreadcrumbComponent
      options={[
        ...categoriesBreadcrumb,
        {
          active: true,
          href: INTERNAL_URI.CATEGORY,
          as: categoryHref(data.get('id'), data.get('urlKey')),
          name: data.get('name'),
        },
      ]}
    />
  );
};

export default Breadcrumb;
